module.exports = __webpack_public_path__ + "img/attendee-filter.4b4bca90.jpg";